export default {
  path: '/',
  meta: {
    name: '选址需求',
    title: '选址需求',
  }
};
